import { useEffect } from "react";
import Blog from "./blog";

export const BlogPage = () => {
  useEffect(() => {
    document.body.classList.add("blog-page");
    const menu = document.getElementById("menu");
    const title = document.getElementById("menu-title");
    const links = document.querySelectorAll("#menu a");
    if (menu) {
      menu.classList.add("navbar-dark", "detail-page-nav");
      menu.style.background = "linear-gradient(180deg, #093946 0%, #398ba2 100%)";
      menu.style.textShadow = "0 6px 24px rgba(0, 0, 0, 0.35)";
      menu.style.borderBottom = "1px solid rgba(255, 255, 255, 0.08)";
      links.forEach((l) => (l.style.color = "#ffffff"));
      if (title) title.style.color = "#ffffff";
    }
    return () => {
      document.body.classList.remove("blog-page");
      if (menu) {
        menu.classList.remove("navbar-dark", "detail-page-nav");
        menu.style.background = "";
        menu.style.textShadow = "";
        menu.style.borderBottom = "";
      }
      links.forEach((l) => (l.style.color = ""));
      if (title) title.style.color = "";
    };
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#ffffff", paddingTop: "30px", paddingBottom: "1.5rem", overflow: "hidden" }}>
      <Blog />
    </div>
  );
};

export default BlogPage;
